/**
 * Source: https://play.tailwindcss.com/vG2syWDU3B
 */
module.exports = (theme) => ({
  [`@media (min-width: ${theme("screens.md")})`]: {
    ".upsale-block": {
      background: "linear-gradient(to bottom, transparent 40%, #f2f2f2 40%, #f2f2f2 100%)",
    },
  },
  ".upsale-wrap": {
    "@apply ds-m-auto ds-max-w-[1024px] ds-px-[21px] ds-my-lg": {},
  },
  ".upsale-block": {
    "@apply ds-ml-0 ds-flex ds-max-w-[614px] ds-flex-wrap ds-py-sm md:ds-relative md:ds-pl-xl ds-pb-lg ds-min-h-[310px]": {},
  },
  ".upsale-block .side-a": {
    "@apply ds-basis-full md:!ds-order-first md:ds-basis-7/12 lg:ds-basis-3/5": {},
  },
  ".upsale-block .side-a .title": {
    "@apply ds-text-6xl ds-font-bold ds-leading-3xl ds-pt-sm md:ds-pt-[90px]": {},
  },
  ".upsale-block .side-a p": {
    "@apply ds-py-sm ds-text-base md:ds-pr-2xl ds-leading-[28px]": {},
  },
  ".upsale-block .img-wrap": {
    "@apply ds-order-first ds-basis-full md:ds-basis-4/12 md:ds-pb-[20px]": {},
  },
  ".upsale-block .img-wrap figure": {
    "@apply ds-mx-auto ds-w-[300px] md:ds-w-[210px]": {},
  },
  ".upsale-block .img-wrap img": {
    "@apply ds-h-[300px] ds-rounded-full ds-object-cover md:ds-h-[210px]": {},
  },
  ".upsale-block .button-wrap": {
    "@apply ds-flex ds-basis-full ds-py-0 md:ds-basis-4/12 ds-pl-0 md:ds-mt-sm md:ds-absolute md:ds-right-[38px] lg:ds-right-[28px] md:ds-top-[230px]":
      {},
  },
  ".upsale-block .link": {
    "@apply md:!ds-px-[35px] md:!ds-py-[9px]": {},
  },
  ".upsale-block .invisible-placeholder": {
    "@apply ds-invisible md:ds-basis-7/12 lg:ds-basis-3/5": {},
  },
});
